// saved for later
// import config from 'config';
import {HEADTOHEAD} from './mockData/MockHeadToHeadData'

const LOAD = 'football/teamH2H/LOAD';
const LOAD_SUCCESS = 'football/teamH2H/LOAD_SUCCESS';
const LOAD_FAIL = 'football/teamH2H/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: false,
          loaded: true,
          H2H: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, matchId) {
  return globalState.football
      && globalState.football.teamH2H
      && globalState.football.teamH2H[matchId]
      && globalState.football.teamH2H[matchId].loading;
}

export function load(matchId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: () => Promise.resolve(HEADTOHEAD),
    matchId
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/teamHeadToHead.js